// @generated by TypeGen from LogbookModel/Status/AlertStatus.swift - DO NOT EDIT

import type { ILogLighting } from "../Lighting"
import type { IAlertLoudness } from "./AlertEngineModel"

export interface IAlertStatusData {
}

export interface IAlertAnchorDriftData extends IAlertData {
  distance: number;
}

export interface IAlertData {
}

export interface IAlertDepthData extends IAlertData {
  depth: number;
}

export interface IAlertLightsData extends IAlertData {
  recommended?: ILogLighting;
  recorded?: ILogLighting;
}

export interface IAlertLostPositionData extends IAlertData {
  reason: IAlertLostPositionReason;
}

export interface IAlertManOverboardData extends IAlertData {
  status: IAlertManOverboardStatus;
  mmsi?: number;
  latitude?: number;
  longitude?: number;
  triggeredByUserId?: number;
}

export interface IAlertMessageData extends IAlertData {
  message: string;
  severity: IAlertStatus;
  loudness: IAlertLoudness;
  senderUserId: number;
}

export interface IAlertPressureData extends IAlertData {
}

export enum IAlertLostPositionReason {
  disconnected = "disconnected",
  stale = "stale",
  jump = "jump",
  invalidFix = "invalidFix",
}

export enum IAlertManOverboardStatus {
  emitterActivated = "emitterActivated",
  manualButtonActivated = "manualButtonActivated",
  manual = "manual",
  unknown = "unknown",
}

export enum IAlertStatus {
  ok = 0,
  resolved = 1,
  ignored = 2,
  acknowledged = 3,
  warning = 4,
  alarm = 5,
}

export enum IAlertStatusType {
  anchorDrift = "anchorDrift",
  depth = "depth",
  lights = "lights",
  pressure = "pressure",
  wind = "wind",
  lostPosition = "lostPosition",
  message = "message",
  manOverboard = "manOverboard",
  test = "test",
}

export enum IAlertStatusPhase {
  notice = 0,
  watch = 1,
  skipper = 2,
  allHands = 3,
}
